import { QueryClient } from '@tanstack/react-query'

// Единый экземпляр: его делят QueryProvider (рендер), роутер-контекст (гейты
// beforeLoad читают кэш без хуков) и bootstrap-prefetch сессии.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: 0 },
  },
})
